
//会员等级，会员设置页面接口
import { get, post, postJson, postBlob, postJsonBlob, deleteApi } from '../axios2'
const RESOURCE_BASE_PATH = '/PointActivityAnalyticController';

const RESOURCE_BASE_PATH2 = '/PointActivityEffectDetails';


/***
 * 数据分析-奖品统计-导出表格数据
 * /PointActivityAnalyticController/exportTablePrizeStates
 */
export const getExportTablePrizeStates = p => postJson(`${RESOURCE_BASE_PATH}/exportTablePrizeStates`, p)

/***
 * 数据分析-活动数据-折线图
 * @param p/
 */
export const getChartEffectDetails = p => get(`${RESOURCE_BASE_PATH}/getChartEffectDetails`, p)

/***
 * 数据分析-奖品统计-折线图
 * 
 */
export const getChartPrizeStates = p => get(`${RESOURCE_BASE_PATH}/getChartPrizeStates`, p)


/***
 * 数据分析-活动数据-折线图
 * @param p/
 */
export const getGoodRecords = p => get(`${RESOURCE_BASE_PATH2}/goodRecords`, p)

/***
 * 积分中心-积分商城-兑换记录
 * @param p/
 */
export const getExchangeActivityRecord = p => postJson(`${RESOURCE_BASE_PATH}/getExchangeActivityRecord`, p)


/***
 * 数据分析-活动数据-数据总览
 * @param
 */
export const getSumEffectDetails = p => get(`${RESOURCE_BASE_PATH}/getSumEffectDetails`, p)

/***
 * 数据分析-奖品统计-表格数据
 * @param
 */
export const getTablePrizeStates = p => get(`${RESOURCE_BASE_PATH}/getTablePrizeStates`, p)

/***
 * 数据分析-积分任务-折线图数据
 * @param
 */
export const checkRecord = p => get(`${RESOURCE_BASE_PATH2}/getChartEffectChart`, p)


/***
 * 数据分析-补签卡获取记录-表格数据
 * @param
 */
export const checkListBu = p => get(`${RESOURCE_BASE_PATH}/gameTaskRecord`, p)


/***
 * 数据分析-积分任务-汇总数据
 * @param
 */
export const getCouponData = p => get(`${RESOURCE_BASE_PATH2}/getSumEffectDetails`, p)

/***
 * 活动统计汇总-试用回购礼
 * @param
 */
export const getTrialRebuyData = p => get(`/trialRebuy/dataOverview`, p)


/***
 * 数据分析-积分任务-折线图数据
 * @param
 */
export const trialRebuyRecord = p => get(`/trialRebuy/activityStatisticsDetails`, p)

/***
 * 数据分析-积分任务-试用回购礼导出
 * @param
 */
export const trialRebuyExports = p => get(`/trialRebuy/exportActivityStatisticsDetails`, p)

/***
 * 数据分析-积分任务-列表数据
 * @param
 */
export const getCouponTable = p => get(`${RESOURCE_BASE_PATH2}/getTableEffectDetails`, p)

/***
 * 数据分析-积分任务-签到记录
 * @param
 */
export const checkList = p => get(`${RESOURCE_BASE_PATH2}/singleRecords`, p)

/***
 * 数据分析-积分任务-中奖记录
 * @param
 */
export const awardRecord = p => get(`${RESOURCE_BASE_PATH2}/pointActivityPrizeDetail`, p)

//中奖记录-邀请类
export const awardRecNew = p => get(`${RESOURCE_BASE_PATH2}/pointInviteActivityPrize`, p)

//中奖记录-邀请开卡单独抽离出来
export const awardRecNewOne = p => get(`${RESOURCE_BASE_PATH2}/pointInviteCardActivityPrize`, p)

//开卡记录----邀请统计 
export const invaidStatics = p => get(`${RESOURCE_BASE_PATH2}/pointInviteStatisticsList`, p)

//开卡记录-邀请统计-明细
export const invitationDetailNew = p => get(`${RESOURCE_BASE_PATH2}/pointInviteStatisticsDetail`, p)

// 开卡记录-被邀请人明细
export const getInviteDetail = p => get(`/invitePointActivity/inviteDetail`, p)


//导出
export const exportRecord = p => postJson(`${RESOURCE_BASE_PATH2}/exportPointActivityPrizeDetail`, p)

export const exportPointActivityPrizeDetailBlob = p => postJson(`${RESOURCE_BASE_PATH2}/exportPointActivityPrizeDetail`, p)

// 导出领奖记录
export const exportAwardRecord = p => postJson(`${RESOURCE_BASE_PATH2}/exportPointActivityPrizeDetailForPurchase`, p)

// 中奖记录-邀请开卡
export const exportInviteCardAwardRecord = p => postJson(`${RESOURCE_BASE_PATH2}/exportPointInviteCardActivityPrize`, p)

//导出-邀请类
export const exportRecNew = p => postJson(`${RESOURCE_BASE_PATH2}/exportPointInviteActivityPrize`, p)

/***
 * 数据分析-积分任务-实物名单
 * @param
 */
export const inKindList = p => get(`${RESOURCE_BASE_PATH2}/goodRecords`, p)

/***
 * 数据分析-积分任务-用户资料明细
 * @param
 */
export const improveList = p => get(`${RESOURCE_BASE_PATH2}/memberImproveRecords`, p)

/***
 * 数据分析-积分任务-标记状态
 * @param
 */
export const signIssuance = p => get(`${RESOURCE_BASE_PATH2}/markingSendStatus`, p)


/**
 * 数据分析-获取礼包活动下单转化数据
 * @parm
 */
// export const getShopGiftParticipateConver = p => get(`giftBag/getShopGiftParticipateConver`, p)
 
export const getShopGiftParticipateConver = p => get(`PointActivityEffectDetails/getSumEffectOrder`, p)


// 拼券明细
export const getSplitCouponlist = p => postJson(`/splitCoupon/coupon/page`, p)

// 优惠卷统计
export const getStatisticsCouponlist = p => postJson(`splitCoupon/coupon/statistics`, p)

// 团队详情
export const CouponDetail = p => postJson(`/splitCoupon/group/detail`, p)

// 组团明细
export const CouponDetailmember = p => get(`/splitCoupon/group/member/list/${p}`)

// 查询裂变神券
export const CouponDetailID = p => get(`/splitCoupon/${p}`)

// 抽奖机会赠送记录查询列表接口
export const commentDraw = p => get(`/comment/draw/page`, p)

// 抽奖机会赠送记录查询列表接口
export const participation = p => get(`/PointActivityAnalyticController/page/participation`, p)

// 积分锁权参与记录
export const lockRecordPage = p => postJson(`/pointLock/lockRecordPage`, p)

// 积分锁权参与记录
export const lockRecordExport = p => postJson(`/pointLock/lockRecordExport`, p)

// 积分锁权参与记录导出
export const gameTaskRecord = p => get(`/PointActivityAnalyticController/gameTaskRecord`, p)

// 定时开奖参与记录
export const joinRecordPage = p => postJson(`/timePrize/joinRecordPage`, p)

// 定时开奖参与记录导出
export const joinRecordExport = p => postJson(`/timePrize/joinRecordExport`, p)

// 定时开奖参-标记中奖
export const markingStatus = p => postJson(`/timePrize/markingStatus`, p)

// 定时开奖参-获取奖品
export const getPrizeList = p => postJson(`/timePrize/getPrizeList`, p)

// 定时开奖参-幸运值获取记录
export const getLuckValueRecord = p => postJson(`/timePrize/getLuckValueRecord`, p)

//定时开奖导出
export const exportLuckValue = p => postJson(`/timePrize/exportLuckValueRecord`, p)

// 会员升级礼参与记录查询
export const memberUpGrade = p => postJson(`/memberLevelGift/getMemberUpgradeGiftRecord`, p)

// 情书贺卡参与记录查询
export const BilletDoux = p => postJson(`/LoveLetterGreetingCardController/participants/page`, p)

// 情书贺卡获取记录查询
export const BilletReceive = p => postJson(`/LoveLetterGreetingCardController/love-letter/acquisition/page`, p)

// 实物导出验证码
export const getExportCode = p => get(`/seller/getSellerCheckCode`)

// 实物导出验证码
export const getExportxlxs = p => postBlob(`/jd-hd-web/PointActivityEffectDetails/exportGoodRecords`, p)

// 锁权 导出验证码
export const getExportLockRight = p => postBlob(`/jd-hd-web/lockRightRecord/export`, p)
// 锁权-中奖记录 收货信息 导出验证码
export const getExportLockWin = p => postBlob(`/jd-hd-web/lockRight/winRecord/export`, p)

// 批量标记发货状态
export const markDeliveryStatus = p => postJson(`/PointActivityAnalyticController/markDeliveryStatus/batch`, p)

// 确权 发货
export const lockSendStatus = p => postJson(`/lockRight/markingSendStatus`, p)
// 
export const DeliveryStatus = (id,deliveryFlag) => postJson(`/PointActivityAnalyticController/markDeliveryStatus?id=${id}&deliveryFlag=${deliveryFlag}` )

export const markingSendStatus = (source,p) => postJson(`/PointActivityEffectDetails/markingSendStatus/batch?source=${source}`, p)

export const getActivityRuleFields = p => get(`/PointActivityEffectDetails/getActivityRuleFields/${p}`)

///jd-hd-web
export const getSumEffectDetailsV1 = p => get(`/PointActivityEffectDetails/getSumEffectDetailsV1`, p)

//
export const getChartEffectChartV1 = p => get(`/PointActivityEffectDetails/getChartEffectChartV1`, p)


// 数据汇总
export const getSmartDataSum = p => get(`/PointActivityEffectDetails/smartDataSum`, p)

// 数据明细
export const getSmartDataDetail = p => get(`/PointActivityEffectDetails/smartDataDetail`, p)

// getCouponTable

//拼券明细分页
export const splitCouponPage = p => get(`/super-splitCoupon/coupon/page`, p)

//团队详情
export const splitCouponGroup = p => postJson(`/super-splitCoupon/group/detail`, p)
//团队详情
export const groupMember = p => get(`/super-splitCoupon/group/member/list/${p}`)


//优惠券列表/
export const getCoupon = p => get(`/super-splitCoupon/coupon/${p}`)

//优惠券列表/
export const splitCouponStatistics = p => postJson(`/super-splitCoupon/coupon/statistics`, p)

//开卡记录/
export const openCardRecord = p => get(`/memberCard/openCardRecord`, p)
//预约记录/
export const appointment = p => postJson(`/freeTrial/appointment`, p)

// 加购记录
export const addCartpage = p => get(`/incentivesForAddCart/page`, p)
// 加购详情
export const addCartDetail = p => get(`/incentivesForAddCart/detail/`+ p)

// 锁权记录 lockRightRecord
export const lockRightRecord = p => get(`/lockRightRecord/page`, p)

// 中奖记录 积分锁权 lockRightRecord
export const lockWinRecord = p => get(`/lockRight/winRecord/page`, p)

// 修改发货信息 积分锁权-发货信息
export const updateReceiveAddress = p => postJson(`/lockRight/updateReceiveAddress`, p)

/**中奖记录列表添加地址信息接口 */
export const writeReceiveAddress = p => postJson(`/lockRight/winRecordAddAddress`, p)




//积分确权数据统计接口
export const getSumLockEffectJi = p => get(`/lockRightRecord/getSumLockEffect`, p)

//积分确权数据明细
export const getDetailLockEffectJi = p => get(`/lockRightRecord/getDetailLockEffect`, p)

//积分导出
export const exportJi = p => postBlob(`/jd-hd-web/lockRightRecord/statistics/export`, p)

// 发货接口（单个）
export const markingSendStatusLockRight = p => postJson(`/lockRight/markingSendStatus`, p)

// 打榜有礼数据总览
export const getDataOverview = p => get(`/order-rank/activityStatistic/dataOverview`, p)

// 打榜有礼数据明细
export const getDetailPage = p => get(`/order-rank/activityStatistic/detail/page`, p);

// 打榜有礼活动导出
export const getExport = p => postJsonBlob(`/jd-hd-web/order-rank/activityStatistic/export`, p);

// 打榜有礼实物导出
export const goodsRecordExport = p => postJsonBlob(`/jd-hd-web/order-rank/goodsRecord/export`, p);

// 打榜有礼领奖记录导出
export const winRecordExport = p => postJsonBlob(`/jd-hd-web/order-rank/winRecord/export`, p);

// 打榜有礼领奖记录
export const getWinRecordPage = p => get(`/order-rank/winRecord/page`, p);

// 打榜有礼实物奖品名单
export const getGoodsRecordPage = p => get(`/order-rank/goodsRecord/page`, p);

// 查询派样/回购下单商品列表接口
export const getOrderRecordPage = p => get(`/sendReBuy/orderRecordPage`, p);

// 导出-派样/回购下单商品列表接口
export const orderRecordPageExport = p => postJsonBlob(`/jd-hd-web//sendReBuy/orderRecordPage/export`, p);

// 派样回购数据统计概况
export const getSumEffect = p => get(`/sendSampleRecord/getSumEffect`, p);

// 派样回购数据统计详细
export const getDetailEffect = p => get(`/sendSampleRecord/getDetailEffect`, p);

// 派样回购数据统计详细(含合计)
export const getDetailIncludeTotal = p => get(`/sendSampleRecord/getDetailIncludeTotal`, p);

// 派样回购数据统计导出
export const sendSampleRecordExport  = p => postJsonBlob(`/jd-hd-web/sendSampleRecord/export`, p);

// 派样下单创建活动
export const saveActivity  = p => postJson(`/sendReBuy/saveActivity`, p);

// 派样下单详情
export const getSendReBuyDetail = p => get(`/sendReBuy/detail/${p}`)

// 获取随单发详情接口
export const promoReBuyDetail = p => get(`/promoSendReBuy/detail/${p}`)

// 互动/京获客生成京东/云起人群
export const generateCrowBySearch  = p => postJson(`/crowd-generate/generateCrowBySearch`, p);

// 查询活动奖项
export const getPrizeNames = p => get('/paradiseAndTaskCommon/activity/prize',p)

// 实物撤销接口
export const pointsExchangeQuash = p => get('/pointsExchange/record/quash',p)
//随单发
export const promoSave = p => postJson('/promoSendReBuy/saveActivity',p)

//修改活动通用接口
export const paradise = p => postJson('/paradiseAndTaskCommon/activity/update',p)

//手动发放令牌
export const promoSendReBuyToken = p => postJson('/promoSendReBuy/token/send',p)

//重新发放令牌
export const reToken = p => get('/promoSendReBuy/token/reSend',p)

// 录入快递单号
export const markingSendStatusForPointActivity = p => postJson(`/PointActivityAnalyticController/markingSendStatus`, p);

// 满额有礼-实物导出下载
export const fullGiftRecord = p => postJson(`/PointActivityEffectDetails/exportGoodRecords`, p)

// 数据统计-导出
export const exportStatistics = p => postJson(`/PointActivityEffectDetails/exportSum`, p)

//试用回购礼-导出
export const exportStatisticsTrial = p => postJson(`/trialRebuy/exportSum`, p)

// 数据统计-导出字段获取
export const getFieldJsonConfig = p => get(`/PointActivityEffectDetails/fieldJsonConfig/query?type=1`, p)

// 数据统计-导出字段保存
export const saveFieldJsonConfig = p => postJson(`/PointActivityEffectDetails/fieldJsonConfig/save`, p)

// 数据统计-表格-导出
export const exportTableStatistics = p => postJson(`/PointActivityEffectDetails/exportChartEffectChart`, p)

//京东0元试用活动参与记录
export const getTrialActivityRecord = p => postJson('/trialActivity/joinRecordPage', p)

//京东0元试用活动查询试用报告
export const getTialReportAnswer = p => get('/trialActivity/selectAnswer', p)

//京东0元试用活动标记中奖
export const markWinTrial = p => postJson('/trialActivity/markWin', p)

//查询试用报告问题以及问题的选项
export const getTialReportOptions = p => get(`/trialActivity/selectQuestion/${p}`)

//京东0元试用活动参与记录导出接口
export const exportZeroTrialRecord = p => postJson('/trialActivity/joinRecordExport', p)

//保存/编辑活动接口
export const saveActivityCommon = p => postJson('/activity-common/save', p)

//活动详情
export const getActivityDetailCommon = p => get(`/activity-common/detail/${p}`)
// 数据统计-导出字段获取
export const trialRebuyConfig = p => get(`/trialRebuy/record`, p)

//试用复购-订单明细
export const trialRebuyConfigOrder = p => postJson(`/trialRebuy/orderDetail`, p)


export const exportTrialRecord = p => postJson(`/trialRebuy/exportOrderDetail`, p)

//试用礼
export const trialLins = p => postJson(`/trialRebuy/winRecord`, p)

//用户信息收集
export const improveRecordPage = p => postJson(`/bigTurntableDraw/improveRecordPage`, p)

//用户信息收集导出
export const exportPlatformImproveRecord = p => postJson(`/bigTurntableDraw/exportPlatformImproveRecord`, p)

// 移除用户促销令牌
export const removeUserPromoToken = (p) => deleteApi(`/pointsExchange/removeUserPromoToken`,p);
//抽奖次数变更
export const saveGameTaskRecord = p => postJson('/PointActivityEffectDetails/saveGameTaskRecord', p)

//参与用户卡片详情
export const saveUserCardDetail = p => postJson('/PointActivityEffectDetails/userCardDetail', p)

//抽卡记录
export const gachaRecordList = p => get('/PointActivityEffectDetails/pointActivityGachaRecord', p)

// 抽奖卡导出
export const exportGachaRecords = p => postJson('/PointActivityEffectDetails/exportPointActivityGachaRecord', p)

//试用回购礼
export const exportSum = p => postJson('/trialRebuy/exportSum', p)

//积分锁权订单明细
export const getLockOrderPage = p => postJson('/pointLock/lockOrderPage', p)

//积分锁权订单明细导出
export const exportLockOrder = p => postJson('/pointLock/lockOrderExport', p)

//组队瓜分开团记录
export const teamSharePrizeRecords = p => get('/PointActivityEffectDetails/teamSharePrizeRecord', p)

//开团记录导出
export const exportTeamSharePrizeRecords = p => postJson('/PointActivityEffectDetails/exportTeamSharePrizeRecord', p)

//被邀请人明细
export const memberInviteDetails = p => get('/PointActivityEffectDetails/memberInviteDetail', p)

//被邀请人明细导出
export const exportMemberInviteDetails = p => postJson('/PointActivityEffectDetails/exportMemberInviteDetail', p)


// 任务完成记录
export const taskCompletion = p => get('/PointActivityAnalyticController/gameTaskRecord', p)

// 任务完成记录导出
export const exportGameTaskRecord = p => postJson('/PointActivityAnalyticController/exportGameTaskRecord', p)

//粉丝
export const participationPagetion = p => postJson('/PointActivityEffectDetails/fanPunchIn/participationPage', p)

//粉丝参与记录导出
export const fansExport = p => postJson('/PointActivityEffectDetails/fanPunchIn/participationExport', p)

//入会有礼
export const joinRecordGift = p => postJson('/joinGift/joinRecord', p)

export const exportMemberGift = p => postJson('/joinGift/joinRecord/export', p)

//销售打榜-榜单实况
export const salesRankSummary = p => postJson('/salesRank/summary', p)

//销售打榜-实况排名接口
export const rank = p => postJson('/salesRank/rank', p)

//销售打榜-榜单实况明细接口
export const rankDetail = p => postJson('/salesRank/rankDetail', p)

//销售打榜-导出
export const rankExportDetail = p => postJson('/salesRank/exportOrderDetail', p)

//订单明细分页接口
export const orderDetailPage = p => postJson('/salesRank/orderDetailPage', p)

//下载模板
export const userProfile = p => postBlob(`/jd-hd-web/show-product/userProfile/${p.activityId}/importTmplate`,p)

//销售打榜-参与记录
export const rankingRecords = p => postJson('/salesRank/joinRecordPage', p)

//销售参与明细
export const exportJoinRecords = p => postJson('/salesRank/exportJoinRecord', p)

//生命周期参与记录
export const userLifeRecords = p => postJson('/userLifeCycle/participationPage', p)

export const orderDetailPages  = p => get(`/PointActivityEffectDetails/orderDetailPage`, p);

export const exportuserLife = p => postJson('/userLifeCycle/participationExport', p)

export const exportTicketPayRecord = p => postJson('/pointAuction/exportTicketPayRecord', p)

export const exportBidRecords = p => postJson('/pointAuction/exportBidRecords', p)

export const userLifeCycle = p => get(`/userLifeCycle/stages/${p}`)

// 数据分析-实物奖品名单（所有活动）
export const getAllGoodsRecords  = p => get('/PointActivityEffectDetails/goodsRecords/all', p);

/***
 * 数据分析-中奖记录-补发积分接口
 * @param
 */
export const resendPoints = p => get(`/PointActivityEffectDetails/resendPoints`, p)
// 加购记录-导出
export const exportMemberAddCartRecord  = p => postJson('/incentivesForAddCart/exportMemberAddCartRecord', p);


// 趣味游戏参与记录导出
export const exportFunGame = p => postJson('/funnyGame/joinRecord/export', p)

// 趣味游戏参与记录
export const joinGameRecords = p => get(`/funnyGame/joinRecord`, p)

// 趣味游戏参与记录详情
export const joinGamedetail = p => get(`/funnyGame/joinRecord/detail`, p)

// 趣味游戏积分记录
export const joinGamedetailOne = p => get(`/funnyGame/scoreRecord`, p)

//积分竞拍
export const pointAuctions = p => postJson('/activity-common/save', p)


// 数据分析-实物奖品名单（所有活动）
export const dealRecords  = p => get('/pointAuction/dealRecords', p);

//积分竞拍活动导出
export const exportDealRecords  = p => postJson('/pointAuction/exportDealRecords', p);


export const prizeRecords  = p => get('/pointAuction/prizeRecords', p);


//领奖记录导出
export const exportPrizeRecords  = p => postJson('/pointAuction/exportPrizeRecords', p);

// 门票支付记录
export const BilletDouxTen = p => get('/pointAuction/getTicketPayRecord', p);

//出价记录
export const BilletDouxEleven = p => get('/pointAuction/bidRecords', p);

//成交记录
export const BilletDouxTwelve = p => get('/pointAuction/dealRecords', p);

export const remainScore = p => get(`/funnyGame/scoreRecord/remainScore`, p)

// 登记生日信息导出
export const exportBirth  = p => postJson('/BirthDayGiftController/exportBirthdayInfo', p);
// 入会打榜-被邀请人明细
export const joinInviteDetail = p => get(`/order-rank/inviteRecord`, p)

// 入会打榜-被邀请人明细导出
export const exportGiftList = p => postJson(`/PointActivityEffectDetails/goodsRecords/all/export`, p)
// 时光许愿池活动保存或更新
export const saveOrUpdateTimeWishPool  = p => postJson('/timeWishPool/saveOrUpdate', p);

// 时光许愿池活动详情
export const getTimeWishPoolDetail  = p => get('/timeWishPool/detail', p);

//购物车锦鲤保存
export const saveOrUpdateShoppingCartKoi  = p => postJson('/shoppingCartKoi/saveActivity', p);

// 购物车锦鲤详情
export const getShoppingCartKoiDetail = p => get(`/shoppingCartKoi/detail/${p}`)

// 购物车锦鲤参与记录
export const getShoppingCartKoiJoinRecord = p => postJson(`/shoppingCartKoi/participation/page`, p)

// 购物车锦鲤参与记录导出
export const exportShoppingCartKoiJoinRecord = p => postJson(`/shoppingCartKoi/participation/export`, p)

// 购物车锦鲤被邀请人记录
export const getShoppingCartKoiInviteRecord = p => postJson(`/shoppingCartKoi/invite/page`, p)

// 购物车锦鲤被邀请人记录导出
export const exportShoppingCartKoiInviteRecord = p => postJson(`/shoppingCartKoi/invite/export`, p)

// 保存打包一口价活动
export const saveOrUpdatePackageFixedPrice  = p => postJson('/packageFixedPrice/saveActivity', p);

// 打包一口价活动详情
export const getPackageFixedPriceDetail  = p => get(`/packageFixedPrice/detail/${p}`);

// 打包一口价活动参与记录
export const participationFixedPrice = p => postJson(`/packageFixedPrice/participation/page`, p)

// 打包一口价活动参与记录导出
export const exportParticipationFixedPrice = p => postJson(`/packageFixedPrice/participation/export`, p)
/***
 * 数据分析-中奖记录-实物(随单发)标记发放
 * @param
 */
export const markSendWithOrder = p => postJson(`${RESOURCE_BASE_PATH2}/markSendWithOrder`, p)

// 盖楼有礼-保存/编辑活动接口
export const saveOrUpdateBuildingGift  = p => postJson('/buildingGift/save', p);

// 盖楼有礼活动详情
export const getBuildingGiftDetail  = p => get('/buildingGift/detail',p);

// 小红书晒单礼活动保存/编辑口
export const saveOrUpdateXhsShowProduct = p => postJson('/redNoteShowGift/save', p);

// 小红书晒单礼活动详情
export const getXhsShowProductDetail = p => get('/redNoteShowGift/detail', p)

// 小红书晒单礼-单个审核及批量审核接口
export const processXhsShowProduct = p => postJson('/redNoteShowGift/process', p);


export const exportPublics = p => postJson(`/PointActivityEffectDetails/orderDetailExport`, p)
// 集分冲榜活动保存
export const saveOrUpdateScoreRank  = p => postJson('/scoreRank/save', p);

// 集分冲榜活动详情
export const getScoreRankDetail  = p => get(`/scoreRank/detail/${p}`);

// 粉丝集分应援活动保存
export const saveOrUpdateFanSupport  = p => postJson('/fanSupport/save', p);

// 粉丝集分应援活动详情
export const getFanSupportDetail  = p => get(`/fanSupport/detail/${p}`);

// 晒图PK活动保存
export const saveOrUpdateShowImageGift  = p => postJson('/showImageGift/save', p);

// 晒图PK活动详情
export const getShowImageGiftDetail  = p => get(`/showImageGift/detail/${p}`);

// 日历打卡活动创建及保存
export const saveOrUpdateCalendarCheckIn  = p => postJson('/calendarCheckCardActivity/saveOrUpdate', p);

// 查询日历打卡有礼任务详情
export const getCalendarCheckInDetail  = p => get("/calendarCheckCardActivity/detail",p);

// 日历打卡-单个/批量审核
export const processCalendarCheckIn  = p => postJson('/calendarCheckCardActivity/process', p);

// 创建/编辑AI趣味答题活动
export const saveOrUpdateAiFunnyQuiz  = p => postJson('/aiFunnyQuiz/save', p);

// 查询AI趣味答题活动详情
export const getAiFunnyQuizDetail  = p => get(`/aiFunnyQuiz/${p}`);

// AI趣答参与记录查询
export const getAiFunnyQuizJoinRecord  = p => postJson('/aiFunnyQuiz/joinRecord', p);

// AI趣答参与记录导出
export const exportAiFunnyQuizJoinRecord  = p => postJson('/aiFunnyQuiz/joinRecord/export', p);

//穿搭人格推荐统计查询
export const recommendedPersonalityCountRecord  = p => postJson('/aiFunnyQuiz/recommendedPersonalityCount', p);

//穿搭人格导出
export const recommendedPersonalityCountExport  = p => postJson('/aiFunnyQuiz/recommendedPersonalityCount/expert', p);


// 抽奖记录导出
export const exportLotteryRecord  = p => postJson('/aiFunnyQuiz/prizeDrawRecord/expert', p);

export const awardRecordOne = p => get(`/aiFunnyQuiz/prizeDrawRecord`, p)

// 商品推荐明细
export const recommendProductPage  = p => postJson('/aiFunnyQuiz/recommendProduct/page', p);

//商品推荐明细导出
export const recommendProductExport  = p => postJson('/aiFunnyQuiz/recommendProduct/export', p);
// 百变趣答活动创建及保存
export const saveOrUpdateFunAnswer  = p => postJson('/funnyQuestion/saveOrUpdate', p);

// 查询百变趣答活动详情
export const getFunAnswerDetail  = p => get("/funnyQuestion/detail",p);

// 百变趣答-保存/编辑活动接口
export const saveOrUpdateAnswerGuide  = p => postJson('/answerGuide/save', p);

// 百变趣答-详情
export const getAnswerGuideDetail  = p => get(`/answerGuide/${p}`);
/***
 * 积分兑换优惠券活动创建及保存
 * @param
 */
export const exchangeCouponSaveOrUpdate = p => postJson(`/exchangeCoupon/saveOrUpdate`, p)

/***
 * 查询积分兑换优惠券活动详情
 * @param
 */
export const exchangeCouponDetail = p => get(`/exchangeCoupon/detail`, p)

// 补发奖品任务创建
export const reissuePrizeCreate = p => postJson("/PointActivityEffectDetails/compensation/task", p)

// 查询补偿发放奖品任务
export const reissuePrizeTaskList = p => get("/PointActivityEffectDetails/compensation/task/list", p)

// 分页查询补偿发放奖品记录详情
export const reissuePrizeResult = p => get("/PointActivityEffectDetails/compensation/record/list", p)

// 补偿发放奖品数查询
export const reissuePrizeCount = p => get("/PointActivityEffectDetails/compensation/count", p)

// 补偿发放奖品结果汇总查询
export const reissuePrizeRecordCount = p => get("/PointActivityEffectDetails/compensation/record/count", p)

// 0元试用活动取消人工标记中奖
export const cancelMarkSendWithOrder = p => postJson("/trialActivity/cancelMarkWin", p)

// 数据分析-中奖记录-汇总中奖人数
export const pointActivityPrizeWinUserCount = p => get("/PointActivityEffectDetails/pointActivityPrizeWinUserCount", p)

// 领奖记录汇总中奖人数
export const winRecordWinUserCount = p => get("/order-rank/winRecord/winUserCount", p)

// 试用回购活动-试用/正装领奖记录汇总中奖人数
export const trialActivityRebuyWinRecordWinUserCount = p => postJson("/trialRebuy/winRecord/winUserCount", p)

// 批量上传收货手机号
export const importReceiverMobiles = p => postJson('/trialActivity/import/receiverMobiles', p);

// 补发奖品上传文件接口
export const uploadFileByType = (type,p) => postJson(`/public/upload/file/${type}`, p);

// 打榜-补偿发放奖品数查询
export const getOrderRankCompensationCount  = p => get("/order-rank/compensation/count", p)

// 试用回购活动-试用/正装 补偿发放奖品数查询
export const getTrialActivityRebuyCompensationCount  = p => postJson("/trialRebuy/compensation/count", p)
